exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.treasury-logo {\n  height: 75px;\n  width: 260px;\n  margin: 0 auto;\n}\n.treasury-logo img {\n    width: 55px;\n    height: 75px;\n}\n.treasury-logo label {\n    display: block;\n    font-size: 8pt;\n    font-weight: 600;\n    margin: 0px;\n}\n.danger-notification-icon {\n  width: 28px;\n  height: 28px;\n  line-height: 32px;\n  margin: 0px;\n  margin-right: 15px;\n}\n.not-found-label {\n  color: #455769;\n  font-weight: 600;\n  font-size: 13pt;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-500c6df4","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/NotFoundPage.vue
// module id = 672
// module chunks = 1